(() => {
  const frame=document.querySelector('iframe.mncs-frame[data-mn-site-shell="embedded"]');
  if(!frame)return;
  let pending=false,contentHeight=0,lastWidth=window.innerWidth;
  const mobile=()=>window.innerWidth<=760;
  const setHeight=height=>{
    const value=Math.round(height)+'px';
    frame.style.setProperty?.('--mncs-frame-height',value);
    if(frame.style.height!==value)frame.style.height=value;
  };
  const fit=()=>{
    pending=false;
    if(mobile()){setHeight(contentHeight||1120);return;}
    const landing=!!frame.closest?.('.mn-ad-designer');
    const offset=Math.max(0,frame.getBoundingClientRect().top+(window.scrollY||0));
    setHeight(landing?900:Math.max(480,Math.round(window.innerHeight-offset)));
  };
  const schedule=()=>{if(!pending){pending=true;window.requestAnimationFrame(fit);}};
  const scrollToOptions=offset=>{
    const header=document.querySelector('.shopify-section-group-header-group');
    const margin=header?.getBoundingClientRect().height||64;
    const top=frame.getBoundingClientRect().top+(window.scrollY||0)+offset-margin-12;
    window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  };
  window.addEventListener('message',event=>{
    const data=event.data;
    if(event.source!==frame.contentWindow||data?.version!==1||!mobile())return;
    let origin;try{origin=new URL(frame.src).origin;}catch{return;}
    if(event.origin!==origin)return;
    if(data.type==='mn:customizer:layout'){
      if(!Number.isFinite(data.height)||data.height<100||data.height>20000)return;
      contentHeight=data.height;fit();
      if(Number.isFinite(data.top)&&data.top>=0&&data.top<=data.height){
        scrollToOptions(data.top);
      }
    }else if(data.type==='mn:customizer:begun'){
      window.requestAnimationFrame(()=>scrollToOptions(0));
    }
  });
  window.addEventListener('resize',()=>{
    if(window.innerWidth!==lastWidth){contentHeight=0;lastWidth=window.innerWidth;}
    schedule();
  },{passive:true});
  window.addEventListener('pageshow',schedule);
  frame.addEventListener('load',schedule);
  if(typeof ResizeObserver!=='undefined'){
    const observer=new ResizeObserver(schedule);
    document.querySelectorAll('.shopify-section-group-header-group').forEach(section=>observer.observe(section));
  }
  document.fonts?.ready.then(schedule);
  fit();
})();
